export default "__VITE_ASSET__DuKMs6ZW__"